var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.225 15.475L13.975 13.725L15.725 15.475L16.475 14.725L14.75 13L16.5 11.25L15.75 10.5L14 12.25L12.25 10.5L11.5 11.25L13.25 13L11.5 14.75L12.225 15.475ZM0 16V0L14.3 6H14C13.4167 6 12.8667 6.06667 12.35 6.2C11.8333 6.33333 11.3333 6.51667 10.85 6.75L2 3V6.5L8 8L2 9.5V13L7.4 10.7C7.26667 11.0833 7.16667 11.4625 7.1 11.8375C7.03333 12.2125 7 12.6 7 13V13.05L0 16ZM14 18C12.6167 18 11.4375 17.5125 10.4625 16.5375C9.4875 15.5625 9 14.3833 9 13C9 11.6167 9.4875 10.4375 10.4625 9.4625C11.4375 8.4875 12.6167 8 14 8C15.3833 8 16.5625 8.4875 17.5375 9.4625C18.5125 10.4375 19 11.6167 19 13C19 14.3833 18.5125 15.5625 17.5375 16.5375C16.5625 17.5125 15.3833 18 14 18Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelSend);
export default __webpack_public_path__ + "static/media/icon-cancel-send.a4f9f00b53a5b44ad18de90345c07d36.svg";
export { ForwardRef as ReactComponent };